/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 01/06/2022.
 */
import React, { useCallback, useEffect } from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import ArrowIcon from '../../assets/next_arrow.svg'
import { KITCHENS_MODEL_PAGE } from '../../pages'
import SectionHeadline from '../SectionHeadline'

//import { useBlazeSlider } from 'react-blaze-slider'
//import 'blaze-slider/dist/blaze.css'
import './carousel.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import useEmblaCarousel from 'embla-carousel-react'
import { useEmblaPagination } from '../useEmblaPagination'

const KitchenCarousel = ({
  title = 'Se vores populære modeller',
  sub = 'Vi har et stort udvalg af greb og materialer',
}) => {
  const data = useStaticQuery(graphql`
    query CarouselQuery {
      products: allMetodProductsJson {
        edges {
          node {
            id
            name
            type
            text
            gallery {
              id
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  `)

  const products = data.products.edges
  const OPTIONS = {
    align: 'start',
    dragFree: true,
    //loop: true,
    slidesToScroll: 1,
    breakpoints: {
      '(min-width: 768px)': { slidesToScroll: 2 },
    },
  }

  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS)

  useEffect(() => {
    console.log('KitchenCarousel > are embla ready ??? ')
    //if (emblaApi && emblaApi.slideNodes().length !== products.length) {
    if (emblaApi) {
      console.log('KitchenCarousel > YES EMBLA IS READY ')
      emblaApi.reInit() // Make Embla pick up changes in slide count
    }
  }, [emblaApi, products])

  const { selectedIndex } = useEmblaPagination(emblaApi)
  //const selectedIndex = 0

  const size = 50

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev()
  }, [emblaApi])

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext()
  }, [emblaApi])

  return (
    <>
      <SectionHeadline headline={title} sub={sub}></SectionHeadline>
      <div className="col-12">
        <div className="embla row">
          <div className="embla__viewport col-12 overflow-hidden" ref={emblaRef}>
            <div className="embla__container d-flex">
              {products.map((item, index) => {
                const name = item.node.name

                const image = getImage(item.node.gallery[0])
                return (
                  <Link
                    to={KITCHENS_MODEL_PAGE.gotoPage(name)}
                    key={index}
                    className="embla__slide h-100 noselect text-decoration-none ps-2 me-3 "
                    style={{ flex: '0 0 300px', minWidth: 0 }}
                  >
                    <GatsbyImage
                      width={300}
                      image={image}
                      alt={'Læs mere om ' + name}
                      className="ratio ratio-1x1 overflow-hidden rounded-3"
                      style={{ pointerEvents: 'none' }}
                      imgStyle={{ objectPosition: '0% 0%', objectFit: 'cover' }}
                    />
                    <div className="">
                      <p className="p-small mt-2 fw-bold">{name}</p>
                    </div>
                  </Link>
                )
              })}
            </div>

            <div className="d-flex justify-content-center pt-6 pb-3 ">
              <div className="embla__prev me-4 " onClick={scrollPrev}>
                <div className="d-flex align-items-center h-100">
                  <div
                    className="rounded-circle d-flex justify-content-center align-items-center pointer bg-white item-shadow "
                    style={{ width: size, height: size }}
                  >
                    <ArrowIcon
                      style={{ width: size * 0.4, height: size * 0.5, transform: 'rotate(90deg)' }}
                    ></ArrowIcon>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                {emblaApi?.scrollSnapList().map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="mt-3 rounded-circle mx-1"
                      style={{
                        border: index === selectedIndex ? '3px solid black' : '1px solid black',
                        width: 12,
                        height: 12,
                        opacity: index === selectedIndex ? 1 : 0.3,
                      }}
                    ></div>
                  )
                })}
              </div>

              <div className="ms-4 embla__next " onClick={scrollNext}>
                <div className="d-flex align-items-center h-100">
                  <div
                    className="rounded-circle d-flex justify-content-center align-items-center pointer bg-white item-shadow "
                    style={{ width: size, height: size }}
                  >
                    <ArrowIcon
                      style={{ width: size * 0.4, height: size * 0.5, transform: 'rotate(-90deg)' }}
                    ></ArrowIcon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default KitchenCarousel

/*
export const useDotButton = (emblaApi) => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState([])

  const onDotButtonClick = useCallback(
    (index) => {
      if (!emblaApi) return
      emblaApi.scrollTo(index)
    },
    [emblaApi]
  )

  const onInit = useCallback((emblaApi) => {
    setScrollSnaps(emblaApi.scrollSnapList())
  }, [])

  const onSelect = useCallback((emblaApi) => {
    setSelectedIndex(emblaApi.selectedScrollSnap())
  }, [])

  useEffect(() => {
    if (!emblaApi) return
    console.log('KitchenCarousel > dots = reinit ')
    onInit(emblaApi)
    onSelect(emblaApi)
    emblaApi.on('reInit', onInit).on('reInit', onSelect).on('select', onSelect)
  }, [emblaApi, onInit, onSelect])

  return {
    selectedIndex,
    scrollSnaps,
    onDotButtonClick,
  }
}
*/
